<h2 mat-dialog-title>
  QR-Code der Messstelle
</h2>


<mat-dialog-content>

  <div
    class="loading"
    *ngIf="isLoading">

    <mat-spinner diameter="36"></mat-spinner>

    <span>
      QR-Code wird geladen …
    </span>

  </div>


  <div
    class="fehler"
    *ngIf="!isLoading && loadError">

    <mat-icon>
      error_outline
    </mat-icon>

    <span>
      {{ loadError }}
    </span>

  </div>


  <ng-container
    *ngIf="!isLoading && info">

    <div class="meta">

      <span class="kennzeichnung-label">
        {{ data.kennzeichnungLabel || 'Kennzeichnung' }}
      </span>

      <strong class="kennzeichnung">
        {{ data.kennzeichnung || '–' }}
      </strong>

      <span
        class="langtext"
        *ngIf="data.langtext">

        {{ data.langtext }}

      </span>

      <span class="projekt">
        Projekt: {{ projektText }}
      </span>

    </div>


    <div class="qr-box">

      <img
        *ngIf="qrDataUrl"
        [src]="qrDataUrl"
        alt="QR-Code der Messstelle">

    </div>


    <div class="hinweis">

      <mat-icon>
        visibility
      </mat-icon>

      <span>
        Wer diesen QR-Code scannt, kann die Messstelle mindestens
        im Nur-Lesen-Modus öffnen.
      </span>

    </div>


    <div class="url-box">

      <span>
        {{ info.publicUrl }}
      </span>

      <button
        mat-icon-button
        type="button"
        matTooltip="Link kopieren"
        [disabled]="copying"
        (click)="linkKopieren()">

        <mat-icon>
          content_copy
        </mat-icon>

      </button>

    </div>

  </ng-container>

</mat-dialog-content>


<mat-dialog-actions align="end">

  <button
    mat-button
    type="button"
    (click)="schliessen()">

    Schließen

  </button>


  <button
    mat-stroked-button
    type="button"
    *ngIf="info"
    [disabled]="!qrDataUrl"
    (click)="downloadPng()">

    <mat-icon>
      download
    </mat-icon>

    PNG

  </button>


  <button
    mat-raised-button
    color="primary"
    type="button"
    *ngIf="info"
    [disabled]="!qrDataUrl"
    (click)="drucken()">

    <mat-icon>
      print
    </mat-icon>

    Drucken

  </button>

</mat-dialog-actions>